var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-center h-100"},[_c('spinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }